import { render } from "./IoT.vue?vue&type=template&id=dc964554"
import script from "./IoT.vue?vue&type=script&lang=js"
export * from "./IoT.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src801691255/src/serverlesspressoV3/frontends/vue-order-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__